import { 
    FaXTwitter, 
    FaYoutube, 
    FaLinkedin, 
    FaInstagram, 
    FaTiktok, 
    FaDiscord 
} from "react-icons/fa6";
import { FaFacebookSquare } from "react-icons/fa";

interface SocialProps {
    socialTypes: string;
    socialLink: string;
}

export default function Socials({ attr }: { attr: SocialProps }) {

    const Icon = () => {
        switch (attr.socialTypes.toLowerCase()) {
            case 'x': return <FaXTwitter />;
            case 'youtube': return <FaYoutube />;
            case 'facebook': return <FaFacebookSquare />;
            case 'linkedin': return <FaLinkedin />;
            case 'instagram': return <FaInstagram />;
            case 'tiktok': return <FaTiktok />;
            case 'discord': return <FaDiscord />;
            default: return null;
        }
    };

    const label = `VXI Global Solutions on ${attr.socialTypes}`;

    return (
        <a href={attr.socialLink} target="_blank" rel="noopener noreferrer" aria-label={label}>
            <Icon />
        </a>
    );
}
